import styled from 'styled-components';

/* Estetyka 1:1 z CategoryModal — warianty mają być „tym samym formularzem, tylko dla opcji".
   Szerszy kontener, bo poza nazwą mieści listę opcji z dopłatami. */

/* z-index spójny z resztą warstw panelu (szuflady 1100–1200, potwierdzenia 1300).
   Nad tym modalem stoją dwie warstwy otwierane z jego wnętrza: uploader zdjęcia `z-[1250]`
   i Biblioteka mediów `z-[1260]` — biblioteka otwiera się na uploadzie, więc jest wyżej. */
export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
`;

export const ModalCard = styled.div`
  background: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : '#ffffff')};
  border-radius: 8px;
  max-width: 520px;
  width: 100%;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};
`;

export const ModalTitle = styled.h3`
  font-size: 14px;
  font-weight: 300;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f3f4f6' : '#1e293b')};
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;

  svg {
    width: 16px;
    height: 16px;
    color: #1a4d4d;
  }
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 5px;
  border: none;
  background: transparent;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#f3f4f6')};
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const ModalBody = styled.div`
  padding: 12px 16px;
  overflow-y: auto;
  max-height: calc(90vh - 110px);
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 16px;
  border-top: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};
  background: ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : '#f9fafb')};
`;

export const CancelButton = styled.button`
  padding: 6px 12px;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};
  background: transparent;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#374151')};

  &:hover {
    background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#f3f4f6')};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const SaveButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  border: none;
  background: #1a4d4d;
  color: white;

  &:hover {
    background: #143b3b;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FormLabel = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.secondary};
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 0 12px;
  height: 38px;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#d1d5db')};
  background: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : '#ffffff')};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f3f4f6' : '#1e293b')};
  font-size: 13px;
  transition: border-color 0.15s ease;

  &::placeholder {
    color: ${({ theme }) => (theme.mode === 'dark' ? '#6b7280' : '#9ca3af')};
  }

  &:focus {
    outline: none;
    border-color: #9ca3af;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

/* Wybór typu — dwie karty obok siebie zamiast selecta: różnica „jedna opcja" vs
   „kilka opcji" jest decyzją, którą trzeba przeczytać, a nie rozwinąć. */
export const OptionCards = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
`;

export const OptionCard = styled.button<{ $active: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
  padding: 10px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  background: ${({ $active, theme }) => {
    if (!$active) return 'transparent';
    return theme.mode === 'dark' ? 'rgba(26,77,77,0.25)' : '#f0f7f7';
  }};
  border: 1px solid ${({ $active, theme }) => {
    if ($active) return '#1a4d4d';
    return theme.mode === 'dark' ? '#374151' : '#e5e7eb';
  }};

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const OptionCardTitle = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const OptionCardDesc = styled.span`
  font-size: 11px;
  line-height: 1.35;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const CheckboxRow = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;

  input {
    margin-top: 2px;
    accent-color: #1a4d4d;
  }
`;

export const CheckboxTexts = styled.span`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const OptionsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const OptionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const OptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const OptionNameField = styled.div`
  flex: 1;
  min-width: 0;
`;

/* Próbka koloru — natywny input, ale bez pudełka wokół, żeby wyglądał jak kafelek
   koloru, a nie jak formularz w formularzu. */
export const ColorSwatch = styled.input`
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  padding: 0;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#d1d5db')};
  border-radius: 6px;
  background: transparent;
  cursor: pointer;

  &::-webkit-color-swatch-wrapper { padding: 2px; }
  &::-webkit-color-swatch { border: none; border-radius: 4px; }
  &::-moz-color-swatch { border: none; border-radius: 4px; }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

/* Miniatura zdjęcia opcji — sama jest przyciskiem „zmień", żeby nie mnożyć ikon w wierszu. */
export const OptionThumbButton = styled.button`
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  padding: 0;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#d1d5db')};
  background: ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : '#f9fafb')};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PriceField = styled.div`
  position: relative;
  flex: 0 0 116px;

  input {
    padding-right: 44px;
    text-align: right;
  }
`;

export const PriceSuffix = styled.span`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 11px;
  pointer-events: none;
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const MiniButton = styled.button<{ $variant?: 'secondary' | 'danger' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  background: transparent;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};
  color: ${({ $variant, theme }) => {
    if ($variant === 'danger') return '#dc2626';
    return theme.mode === 'dark' ? '#9ca3af' : '#6b7280';
  }};

  &:hover:not(:disabled) {
    background: ${({ $variant, theme }) => {
    if ($variant === 'danger') return theme.mode === 'dark' ? 'rgba(239,68,68,0.12)' : '#fee2e2';
    return theme.mode === 'dark' ? 'rgba(255,255,255,0.05)' : '#f9fafb';
  }};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  svg { width: 14px; height: 14px; }
`;

export const AddOptionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  background: transparent;
  border: 1px dashed ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#d1d5db')};
  color: ${({ theme }) => theme.colors.text.secondary};

  &:hover:not(:disabled) {
    color: #1a4d4d;
    border-color: #1a4d4d;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg { width: 14px; height: 14px; }
`;

export const HelperText = styled.p`
  margin: 0;
  font-size: 11px;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const ErrorText = styled.p`
  margin: 0;
  font-size: 12px;
  color: #dc2626;
`;
